import { useTranslation } from "react-i18next"
import { graphql, useFragment } from "react-relay"
import { Question } from "@phosphor-icons/react"
import { formatDateString } from "@/lib/format-date"
import { appointmentDrawerQuestionnaire_appointment$key } from "@/modules/common/waiting-room/appointment/__generated__/appointmentDrawerQuestionnaire_appointment.graphql"

// Once the questionnaire is completed, the appointment gets created
// Thus questionnaire completion date corresponds to appointment's creation date
const AppointmentDrawerQuestionnaireFragment = graphql`
  fragment appointmentDrawerQuestionnaire_appointment on Appointment {
    questionnaireCriticalitySummary {
      useCaseName
    }
    createdAt
  }
`

interface AppointmentDrawerQuestionnaireProps {
  appointmentRef: appointmentDrawerQuestionnaire_appointment$key
}
const AppointmentDrawerQuestionnaire = ({ appointmentRef }: AppointmentDrawerQuestionnaireProps) => {
  const { t } = useTranslation()
  const { createdAt, questionnaireCriticalitySummary } = useFragment<appointmentDrawerQuestionnaire_appointment$key>(
    AppointmentDrawerQuestionnaireFragment,
    appointmentRef,
  )

  const useCaseName = questionnaireCriticalitySummary?.useCaseName

  return (
    <div className="flex flex-row items-center gap-2 rounded-lg px-2 py-1">
      <Question className="text-on-surface-subdued h-6 w-6" />
      <span className="flex flex-col items-start text-left">
        <p>
          {t("patient.questionnaire.title")}: {useCaseName}
        </p>
        <p className="text-on-surface-subdued text-xs">
          {t("patient.questionnaire.completedAt")} {formatDateString(createdAt)}
        </p>
      </span>
    </div>
  )
}

export { AppointmentDrawerQuestionnaire }
